<template lang="pug">
main
  PmHeader
  br
  .container
    h1.title Comprobantes Electrónicos Pendientes
    .box.has-text-centered
        table.table.is-bordered.is-striped.is-hoverable.is-fullwidth
          thead
            tr
              th.titulo Comprobante
              th.titulo.centrado
                abbr(title='Fecha de comprobante ( aaaa-mm-dd )') Fecha
              th.titulo Observación
              th.titulo.centrado
                | Eliminar
          tfoot
            tr
              th.titulo Comprobante
              th.titulo.centrado
                abbr(title='Fecha de comprobante ( aaaa-mm-dd )') Fecha
              th.titulo Observación
              th.titulo.centrado
                | Eliminar
          tbody
            tr(v-for = "t in tracks")
              td
                p
                  | {{ t.codigo }}
                p
                  | {{ t.numero }}
              td.centrado {{ t.fecha }}
              td {{ t.observacion }}
              td.centrado
                  a.button.is-danger(
                  @click="borrar(t.id)"
                  ) &times;
</template>

<script>
import PmNotification from '@/components/shared/Notification.vue'
import PmHeader from '../components/layout/Header.vue'

import trackService from '@/services/track'

export default {
  components: {
    PmNotification,
    PmHeader
  },

  data: () => ({
    tracks: [],
    isLoading: false,
    registroBorrado: [],
    radioButton: 'Default'
  }),

  mounted () {
    if (localStorage.getItem('token')) {
      this.$refs.fecha.focus()
      this.usuario = JSON.parse(localStorage.getItem('usuario'))
    } else {
      this.$router.push('/')
    }    
  },
  
  methods: {
    borrar (id) {
      trackService.borrarPendiente(id)
        .then(res => {
          this.registroBorrado = res
          this.getDatosPendientes()
        })
    },

    getDatosPendientes () {
      this.isLoading = true
      trackService.pendiente()
        .then(res => {
          console.log(res.length)
          this.showNotification = res.length === 0
          this.tracks = res
          this.isLoading = false
        })
    }
  },
  beforeMount () {
    this.getDatosPendientes()
  }
}
</script>

<style lang="scss" scoped>
.centrado {
  text-align: center;
}
</style>
